// extracted by mini-css-extract-plugin
module.exports = {"loader":"ChartNewsTooltip_loader__Xqlaj","news":"ChartNewsTooltip_news__1ncJv","source":"ChartNewsTooltip_source__38-6L"};